import { createClient } from "@connectrpc/connect";
import { IDeleteService } from "../../../../abstractions/services/actions/IDeleteService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { TareaService } from "../../../../generated/grpc/configuracion_tarea_pb";
import { grpcTareaDatabase } from "../database/GrpcTareaDatabase";
import { TareaResponse } from "../response/TareaResponse";
import { fx_createTareaGrpcService } from "./TareaGrpcService";

/** Variante gRPC-Web de `TareaDeleteService` (ver ese archivo). */
export class TareaDeleteGrpcService implements IDeleteService<TareaResponse> {
  async deleteAsync(item: TareaResponse): Promise<void> {
    const client = createClient(TareaService, grpcTransportProvider.get());

    try {
      await client.eliminar({ id: item.id });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcTareaDatabase.deleteOneAsync(item.id);
    if (item.clienteId) fx_createTareaGrpcService(item.clienteId).clearCache();
  }
}
